import React from 'react';
import { StyleSheet } from 'react-native';

import { BodyText } from '../../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardQuantityStepperLabel = (
  props: IngredientCardQuantityStepperLabelProps,
) => {
  const { quantity } = props;

  return (
    <BodyText sizeMatch={['22']} style={styles.text}>
      {quantity}
    </BodyText>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    minWidth: 18,
    textAlign: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type IngredientCardQuantityStepperLabelProps = {
  quantity: number;
};
